import firebase, { auth } from 'utils/firebase'
import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";
import {AUTH_STATUSES, authErrors, routes} from "utils/constants";
import {fetchEmployee} from "utils/firestore/employees";
import {makeUser} from "utils/helpers";
import {useData} from "utils/context";
import {setCurrentStore, setSearchAll, setUser} from "utils/selectors";
import {useRouter} from "next/router";
import {useLogout} from "utils/hooks/index";

export const useFirebaseSession = () => {
    const session = useSession();
    const router = useRouter();
    const {start: logout} = useLogout();
    const [status, setStatus] = useState(session.status);
    const { dispatchUser, dispatchCurrentStore, dispatchSearchAll } = useData();

    useEffect(() => {
        const authenticateUser = async () => {
            const credential = firebase.auth.GoogleAuthProvider.credential(session.data.id_token);
            const result = await auth.signInWithCredential(credential);
            const employee = await fetchEmployee(result.user.email);
            const claims = { ...employee, storeIds: employee?.stores || [] }
            const authUser = makeUser({ user: result.user, claims })
            dispatchUser(authUser);
            console.log(JSON.stringify(authUser))
            if (authUser.defaultStore) {
                dispatchCurrentStore(authUser.defaultStore)
                setCurrentStore(authUser.defaultStore)
            } else if (authUser.stores.length > 1) {
                dispatchCurrentStore(authUser.stores[0]);
                setCurrentStore(authUser.stores[0])
                dispatchSearchAll()
                setSearchAll()
            }
            setUser(authUser);
        }

        if (session.status === AUTH_STATUSES.AUTHENTICATED) {
            setStatus(AUTH_STATUSES.AUTHENTICATED);
            authenticateUser().catch(e => {
                console.error("SnorkelBob Login error", e);
                console.log("Logging out");
                logout();
            })
        }

        if (session.status === AUTH_STATUSES.UNAUTHENTICATED) {
            router.push(routes.login);
            return;
        }

    }, [session]);

    useEffect(() => {
        if (session.status !== AUTH_STATUSES.AUTHENTICATED) {
            setStatus(session.status);
        }
    }, [session.status]);

    return { data: session.data, status };
};
